<app-signature-image-cropper *ngIf="isImageCropperDisplaying"
                             [imageChangedEvent]="imageSelectionEvent"
                             (blobEventEmitter)="receiveSignatureImage($event)">
</app-signature-image-cropper>

<div class="card md:p-8" style="    width: 100%;    height: 100%; ">
    <div class="top-content md:w-9 my-3">
        <h1 class="font-bold text-gray-700 text-center">{{ 'sipo.visual-signature-title' | translate }}</h1>
        <form [formGroup]="formGroup" class="form-style flex">
            <!--left half begin-->
            <div class="md:w-6 px-2 flex flex-column justify-content-between">
                <!--form subfield begin-->
                <div class="py-3 hidden">
                    <span
                        class="font-bold">{{ 'sipo.signature-name' | translate }}</span>
                    <app-form-element [formGroup]="formGroup"
                                      [formId]="'signatureName'"
                                      [formLabel]="'sipo.signature-name' | translate"
                                      [type]="FormTypes.TEXT">
                    </app-form-element>
                    <span
                        class="px-4 text-xs text-gray-500">{{ 'sipo.signature-name-info' | translate }}</span>
                </div>
                <!--form subfield end-->
                <!--form subfield begin-->
                <div class="py-3">
                    <span
                        class="font-bold"></span>
                    <app-form-element [formGroup]="formGroup"
                                      [formId]="'name'"
                                      [formLabel]="'sipo.name' | translate"
                                      [type]="FormTypes.TEXT">
                    </app-form-element>
                    <app-form-element [formGroup]="formGroup"
                                      [formId]="'optionalLine1'"
                                      [formLabel]="('sipo.optional-line' | translate) + ' 1'"
                                      [type]="FormTypes.TEXT">
                    </app-form-element>
                    <span
                        class="px-4 text-xs text-gray-500">{{ 'sipo.optional-line-ex' | translate }}</span>

                    <!--**************************************************************************
                    This field is optional line 2 form field. Can be open if it's needen in the future
                    *******************************************************************************-->
                    <!--                    <app-form-element [formGroup]="formGroup"-->
                    <!--                                      [formId]="'optionalLine2'"-->
                    <!--                                      [formLabel]="('sipo.optional-line' | translate) + ' 2'"-->
                    <!--                                      [type]="FormTypes.TEXT">-->
                    <!--                    </app-form-element>-->
                    <!--                    <span-->
                    <!--                        class="px-4 text-xs text-gray-500">{{ 'sipo.optional-line-ex-2' | translate }}</span>-->
                    <!--**************************************************************************
                        This field is optional line 2 form field. Can be open if it's needen in the future
                    *******************************************************************************-->
                </div>
                <!--form subfield end-->
                <!--form subfield begin-->
                <div class="pt-3">
                    <div class="font-bold mb-3">{{ 'sipo.handwritten-signature' | translate }}</div>
                    <div class="text-gray-500 text-sm font-semibold">{{ 'sipo.handwritten-signature-info' | translate }}
                    </div>
                    <div class="relative cursor-pointer w-fit mt-2">
                        <!--                        <p-button [label]="'sipo.upload-img' | translate" [outlined]="true">-->
                        <!--                            <input class="absolute top-0 left-0 cursor-pointer h-full z-5 opacity-0"-->
                        <!--                                   (change)="onFileSelected($event)"-->
                        <!--                                   [formGroup]="formGroup"-->
                        <!--                                   formControlName="imgFile" type="file">-->
                        <!--                        </p-button>-->
                        <p-button [label]="'sipo.upload-img' | translate" [outlined]="true">
                            <input class="absolute top-0 left-0 cursor-pointer h-full z-5 opacity-0"
                                   (change)="onFileSelected($event)"
                                   [formGroup]="formGroup"
                                   formControlName="imgFile" type="file">
                        </p-button>
                        <!--                        <p-button [label]="'sipo.upload-img' | translate" [outlined]="true"-->
                        <!--                                  (click)="toggleImageCropper()">-->
                        <!--                        </p-button>-->
                        <p-button [label]="'sipo.remove-img' | translate" [outlined]="true" severity="danger"
                                  styleClass="ml-2" (click)="deleteSignatureImage()">
                        </p-button>
                    </div>
                </div>
                <!--form subfield end-->
            </div>
            <!--left half end-->
            <!--right half begin-->
            <div class="md:w-6 px-2 flex flex-column justify-content-between">
                <div>
                    <div class="py-3">
                        <span class="font-bold">{{ 'sipo.preview' | translate }}</span>
                        <!--id-card preview begin-->
                        <app-id-card
                            [signType]="signType ? signType : ''"
                            [previewUrl]="isUserPropertiesArrLength ? signatureImageProperty.userPropertyValue : ''"
                            [name]="formGroup.value.name"
                            [optionalLine1]="formGroup.value.optionalLine1"
                            [optionalLine2]=""
                            [currentTime]="currentTime"

                            [dynamicNameFontDevideNumber]="countNameChars()">
                        </app-id-card>
                        <!--id-card preview end-->
                    </div>
                    <!--form subfield begin-->
                    <div class="py-3">
                        <span class="font-bold">{{ 'sipo.settings' | translate }}</span>
                        <div class="flex justify-content-between align-items-center mt-3">
                            <span>{{ 'sipo.date' | translate }} - {{ 'sipo.time' | translate }}</span>
                            <p-inputSwitch formControlName="dateCheck" (onChange)="toggleTime()"/>
                        </div>
                    </div>
                    <!--form subfield end-->
                </div>
                <!--submit form buttom begin-->
                <div class="flex justify-content-end">
                    <p-button [icon]="submitted ? 'pi pi-check' : 'pi pi-spinner pi-spin'" [disabled]="!submitted"
                              [label]="'sipo.submit' | translate" (click)="submit()"
                              styleClass="ml-3"></p-button>
                </div>
                <!--submit form buttom end-->
            </div>
            <!--right half end-->
        </form>
    </div>
</div>
